import React from 'react'
import PropTypes from 'prop-types'

import {withStyles, Typography} from '@material-ui/core'

const styles = {
    container: {
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        marginBottom: '5em',
        transitionDuration: '1s'
    },

    title: {
        textAlign: 'center',
        fontSize: '1.5em',
        fontWeight: 300,
        paddingTop: '1em',
        paddingBottom: '1em'
    }
}

export const Title = withStyles(styles)(({classes: styles, children}) => (
    <Typography variant="h6" color="inherit" className={styles.title}>
        {children}
    </Typography>
))

Title.propTypes = {
    children: PropTypes.string
}

const TabContainer = function({classes: styles, children, active, title}) {
    const style = !active ? {display: 'none'} : {}

    return (
        <div style={style} className={styles.container}>
            {title && (
                <Title>{title}</Title>
            )}
            {children}
        </div>
    )
}

TabContainer.propTypes = {
    classes: PropTypes.object,
    title: PropTypes.string,
    children: PropTypes.node.isRequired,
    active: PropTypes.bool.isRequired,
    className: PropTypes.string
}

export default withStyles(styles)(TabContainer)
